import PassengerDataRequest from "../../../api/raily/passenger/data/passenger-data.request";
import PassengerDataParams from "./passenger-data-params";

const create = (params: PassengerDataParams): PassengerDataRequest => {
  return {
    passengerUuid: params.passengerUuid,
  };
};

const passengerDataParamsFactory = {
  create,
};

export default passengerDataParamsFactory;
